// extracted by mini-css-extract-plugin
export default {"logo":"BareLogo_logo__1VOfB","slideUp":"BareLogo_slideUp__6aBkE","slideDown":"BareLogo_slideDown__YwkLx"};